import { Button, Typography } from "@material-ui/core";
import LabelsContext from "../../../lang/LabelsContext";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ArticleCard from "../article-card/ArticleCard";
import useStyles from "./ShowArticleCardStyle";
import { useHistory } from "react-router-dom";

export default function ShowArticleCard({ label, articleData }: any) {
  const classes = useStyles();
  const { Labels } = LabelsContext();
  const history = useHistory();

  const goToPrefix = label === Labels.DECIDE_ON_STATUS ? "decideOnStatus" : "reviewerSelection";

  const rightButtons = (id: any) => {
    return (
      <Grid container spacing={1}>
        <Grid item>
          <Button variant="contained" size="small" onClick={() => history.push(`/${goToPrefix}/${id}`)}>
            {Labels.ACTION}
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" size="small" onClick={() => history.push(`/overrideArticle/${id}`)}>
            {Labels.OVERRIDE}
          </Button>
        </Grid>
      </Grid>
    );
  };

  const resultView = (array: any) => {
    if (!array! || array.length === 0) {
      return dataView(<Typography color="textSecondary">{Labels.NO_RESULTS}</Typography>);
    }
    return dataView(
      array.map((data: any, i: number) => {
        return (
          <Grid item xs={12} sm={12}>
            <ArticleCard data={data} index={i} rightComponent={rightButtons} animation={true} />
          </Grid>
        );
      })
    );
  };

  const dataView = (data: any) => {
    return (
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          {data}
        </Grid>
      </Paper>
    );
  };

  return resultView(articleData);
}
